import React,{ useRef, useEffect, useState } from "react";
import BasemapGallery from "@arcgis/core/widgets/BasemapGallery";
import PortalBasemapsSource from "@arcgis/core/widgets/BasemapGallery/support/PortalBasemapsSource";

const BasemapGalleryWidget = ({view,portal,query,activeWidget}) => {
    
    const basegalWidgetDiv = useRef(null);
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        if (activeWidget === "basemapGallery") {
          setVisible(true);
        } else {
          setVisible(false);
        }
      }, [activeWidget]);
    

    
    useEffect(()=> {
        if(basegalWidgetDiv.current && portal.hasOwnProperty('url')){
          let OcPortal=portal
            let source = new PortalBasemapsSource({
                portal: OcPortal,
                query: query
            });

            const basegalWidget = new BasemapGallery({
                container: basegalWidgetDiv.current,
                view: view,
                source: source
            }) 
            
            return() => {
                basegalWidget.destroy()
            }
        }
    },[portal,view])

    let style = { display: "initial" };
    if (visible) {
      style.display = "initial";
    } else {
      style.display = "none";
    }
    
    return(
    <div ref={basegalWidgetDiv} style={style}></div>
    )   
}

export default BasemapGalleryWidget